'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = booking;
exports.isLoaded = isLoaded;
exports.setButtonActive = setButtonActive;
exports.setOrderNumber = setOrderNumber;
exports.allocate = allocate;
exports.freeUpDriver = freeUpDriver;
exports.setCustomStatus = setCustomStatus;
exports.queryBooking = queryBooking;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'booking-status/LOAD';
var LOAD_SUCCESS = 'booking-status/LOAD_SUCCESS';
var LOAD_FAIL = 'booking-status/LOAD_FAIL';
var SET_ORDER_NUMBER = 'booking-status/SET_ORDER_NUMBER';
var SET_CUSTOM_STATUS = 'booking-status/SET_CUSTOM_STATUS';
var LOAD_ALLOCATE = 'allocate/LOAD_ALLOCATE';
var LOAD_ALLOCATE_SUCCESS = 'allocate/LOAD_ALLOCATE_SUCCESS';
var LOAD_ALLOCATE_FAIL = 'allocate/LOAD_ALLOCATE_FAIL';
var LOAD_FREEUPDRIVER = 'freeupdriver/LOAD_FREEUPDRIVER';
var LOAD_FREEUPDRIVER_SUCCESS = 'freeupdriver/LOAD_FREEUPDRIVER_SUCCESS';
var LOAD_FREEUPDRIVER_FAIL = 'freeupdriver/LOAD_FREEUPDRIVER_FAIL';
var SET_BUTTON_ACTIVE = 'freeupdriver/SET_BUTTON_ACTIVE';

var initialState = {
  loaded: false,
  active: false,
  orderNumber: 'GK-'
};

function booking() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true,
        progress: action.progress
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result.data.booking
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        error: action.error
      });
    case SET_ORDER_NUMBER:
      return (0, _extends3.default)({}, state, {
        orderNumber: action.orderNumber
      });
    case LOAD_ALLOCATE:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_ALLOCATE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        allocate: action.result
      });
    case LOAD_ALLOCATE_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        error: action.error
      });
    case LOAD_FREEUPDRIVER:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_FREEUPDRIVER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        freeUpDriver: action.result
      });
    case LOAD_FREEUPDRIVER_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        error: action.error
      });
    case SET_BUTTON_ACTIVE:
      return (0, _extends3.default)({}, state, {
        active: action.active
      });
    case SET_CUSTOM_STATUS:
      return (0, _extends3.default)({}, state, {
        status: action.status
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.booking && globalState.booking.loaded;
}

function setButtonActive(active) {
  return {
    type: SET_BUTTON_ACTIVE,
    active: active
  };
}

function setOrderNumber(orderNumber) {
  return {
    type: SET_ORDER_NUMBER,
    orderNumber: orderNumber
  };
}

// export function load(orderNo) {
//   return {
//     types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
//     promise: (client) => client.get('/loadBooking', {
//       params: {
//         orderNo: orderNo
//       }
//     })
//   };
// }

function allocate(orderNo) {
  return {
    types: [LOAD_ALLOCATE, LOAD_ALLOCATE_SUCCESS, LOAD_ALLOCATE_FAIL],
    promise: function promise(client) {
      return client.put('/allocateBooking', {
        params: {
          orderNo: orderNo
        }
      });
    }
  };
}

function freeUpDriver() {
  return {
    types: [LOAD_FREEUPDRIVER, LOAD_FREEUPDRIVER_SUCCESS, LOAD_FREEUPDRIVER_FAIL],
    promise: function promise(client) {
      return client.put('/freeUpDriver');
    }
  };
}

function setCustomStatus(status) {
  return {
    type: SET_CUSTOM_STATUS,
    status: status
  };
}

function queryBooking(query) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/queries', {
        params: {
          query: query,
          isGraph: true
        }
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/booking.js
// module id = 88
// module chunks = 0